import { render, staticRenderFns } from "./SearchNavItemKeyword.vue?vue&type=template&id=1f08c011&scoped=true&"
import script from "./SearchNavItemKeyword.vue?vue&type=script&lang=js&"
export * from "./SearchNavItemKeyword.vue?vue&type=script&lang=js&"
import style0 from "./SearchNavItemKeyword.vue?vue&type=style&index=0&id=1f08c011&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f08c011",
  null
  
)

export default component.exports